import { c as _c } from "react/compiler-runtime";
import { useMemo, useState } from 'react';
import { StyledCardSection } from '../../../../../common/base/Card';
import Icon from '../../../../../common/base/Icon';
import Text from '../../../../../common/base/Text';
import Dropdown from '../../../../../common/Dropdown';
import { StyledOption } from '../../../../../common/Form/Fields/MultiSelectInput';
import { Div } from '../../../../../common/helpers/StyledUtils';
import Search from '../../../../../common/Search';
interface ProjectOption {
  id: string;
  name: string;
}
interface ProjectFilterDropdownProps {
  projects: ProjectOption[];
  selected_ids: string[];
  disabled?: boolean;
  onChange: (ids: string[]) => void;
}
export function ProjectFilterDropdown(t0) {
  const $ = _c(20);
  const {
    projects,
    selected_ids,
    disabled,
    onChange
  } = t0;
  const [search_term, setSearchTerm] = useState("");
  let t1;
  bb0: {
    if (!search_term) {
      t1 = projects;
      break bb0;
    }
    let t2;
    if ($[0] !== projects || $[1] !== search_term) {
      let t3;
      if ($[3] !== search_term) {
        t3 = project => project.name.toLowerCase().includes(search_term.toLowerCase());
        $[3] = search_term;
        $[4] = t3;
      } else {
        t3 = $[4];
      }
      t2 = projects.filter(t3);
      $[0] = projects;
      $[1] = search_term;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = t2;
  }
  const filtered_projects = t1;
  let t2;
  if ($[5] !== onChange || $[6] !== selected_ids) {
    t2 = (id, checked) => {
      onChange(checked ? [...selected_ids, id] : selected_ids.filter(value => value !== id));
    };
    $[5] = onChange;
    $[6] = selected_ids;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const toggleProject = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      px: 300
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== selected_ids.length) {
    t4 = selected_ids.length ? {
      label: selected_ids.length.toString()
    } : undefined;
    $[9] = selected_ids.length;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== filtered_projects || $[12] !== search_term || $[13] !== selected_ids || $[14] !== toggleProject) {
    t5 = () => <><StyledCardSection><Search borderless={true} small={true} focus={true} placeholder="Find a project..." value={search_term} onChange={setSearchTerm} /></StyledCardSection><StyledCardSection><Div flex={{
          direction: "column"
        }} p={1} max_h={{
          px: 260
        }} style={{
          overflowY: "auto"
        }}>{filtered_projects.length > 0 ? filtered_projects.map(project_0 => <StyledOption key={project_0.id} name={project_0.id} p={{
            x: 2,
            y: 1.5
          }} checked={selected_ids.includes(project_0.id)} onChange={e => toggleProject(project_0.id, e.currentTarget.checked)} label={<Div flex={{
            align: "center",
            gap: 2
          }} min_w={0}><Icon icon="folder" muted={true} /><Text ellipsis={true}>{project_0.name}</Text></Div>} />) : <Div p={{
            x: 3,
            y: 2.5
          }}><Text muted={true}><Icon icon="info" left={true} /> No projects</Text></Div>}</Div></StyledCardSection></>;
    $[11] = filtered_projects;
    $[12] = search_term;
    $[13] = selected_ids;
    $[14] = toggleProject;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== disabled || $[17] !== t4 || $[18] !== t5) {
    t6 = <Dropdown placement="bottom-end" w={t3} outline={true} disabled={disabled} icon="filter_list" label="Project" expand_icon="expand_more" badge={t4}>{t5}</Dropdown>;
    $[16] = disabled;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}